// Composant StepProgressBar modernisé
const StepProgressBar = ({ steps, currentStep }) => {
  return (
    <div className="w-full max-w-4xl mx-auto mb-8 xl:mb-4 2xl:mb-6 3xl:mb-8">
      {/* Barre de progression colorée en haut */}
      <div className="h-0.5"></div>
      
      <div className="flex justify-between items-center relative">
        {/* Ligne de connexion */}
        <div className="absolute top-1/2 left-0 w-full h-0.5 bg-gray-200 -translate-y-1/2 z-0"></div>
        <div 
          className="absolute top-1/2 left-0 h-0.5 bg-gradient-to-r from-indigo-500 to-purple-500 -translate-y-1/2 z-10 transition-all duration-500"
          style={{ width: `${((currentStep - 1) / (steps.length - 1)) * 100}%` }}
        ></div>
        
        {steps.map((step, index) => (
          <div key={step.step} className="flex flex-col items-center relative z-20">
            {/* Cercle de l'étape */}
            <div className={`
              w-12 h-12 xl:w-8 xl:h-8 2xl:w-10 2xl:h-10 3xl:w-12 3xl:h-12 rounded-full flex items-center justify-center text-sm xl:text-xs 2xl:text-xs 3xl:text-sm font-bold transition-all duration-300 mb-3 xl:mb-1 2xl:mb-2 3xl:mb-3
              ${currentStep >= step.step 
                ? 'bg-gradient-to-r from-indigo-500 to-sky-500 text-white shadow-lg scale-110' 
                : 'bg-white border-2 border-gray-300 text-gray-400'}
            `}>
              {step.step}
            </div>
            
            {/* Label de l'étape */}
            <div className={`
              text-center max-w-24 text-sm xl:text-xs 2xl:text-xs 3xl:text-sm font-medium transition-colors duration-300
              ${currentStep >= step.step ? 'text-indigo-600' : 'text-gray-500'}
            `}>
              {step.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StepProgressBar;